import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'nuso-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: false
})
export class SpinnerComponent {

  @Input() diameter = 20;
  @Input() stroke = 3;

  constructor() { }
}
